import styled, { css } from 'styled-components';
import { spacing } from 'styles/globals';
import { borderValue } from 'styles/mixins';
var constantClassName = 'Panel';
var Panel = styled.div.attrs({
  className: constantClassName
}).withConfig({
  displayName: "Panel",
  componentId: "sc-lk06lt-0"
})(["padding:", ";", " ", " ", " .", " + &{padding-top:0;}"], function (p) {
  return p.flush === true ? '0' : spacing[p.size || 'm'];
}, function (p) {
  return typeof p.flush === 'string' && css(["padding-", ":0;"], p.flush);
}, function (p) {
  return p.border && css(["border-", ":", ";"], p.border, borderValue(p.theme));
}, function (p) {
  return p.align && css(["text-align:", ";"], p.align);
}, constantClassName);
export default Panel;